

/// <reference path="EventItem.ts" />

// Generated class EventItemPhase_ManagedObject

class EventItemPhase_ManagedObject extends EventItem
{

    // Relationship: lines
    protected _lines:MIOManagedObjectSet = null;
    get lines():MIOManagedObjectSet {
        return this.valueForKey('lines');
    }
    addLinesObject(value:EventItemLine) {
        this._addObjectForKey(value, 'lines');
    }
    removeLinesObject(value:EventItemLine) {
        this._removeObjectForKey(value, 'lines');
    }
    // Relationship: preset
    set preset(value:Preset) {
        this.setValueForKey(value, 'preset');
    }
    get preset():Preset {
        return this.valueForKey('preset') as Preset;
    }
    // Relationship: rate
    set rate(value:Rate) {
        this.setValueForKey(value, 'rate');
    }
    get rate():Rate {
        return this.valueForKey('rate') as Rate;
    }
}
